import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Flex } from "../../components/Flex";
import { SubHeader } from "../../components/SubHeader";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { userActions } from "../../redux/user/user.slice";
import { Spacing } from "../../theme/Spacing";
import { ProfileEditCompany } from "./components/ProfileEditCompany";
import { ProfileEditPersonal } from "./components/ProfileEditPersonal";
import { PageIcons } from "../../utils/GlobalIcons";

const ContentWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.m};
  padding: 0 ${Spacing.m};
  padding-bottom: ${Spacing.m};
`;

export const ProfileEdit: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;

  useEffect(() => {
    dispatch(userActions.getLoggedInUser({ userId: user?._id! }));
  }, [dispatch, user?._id]);

  return (
    <Flex flexDirection="column">
      <SubHeader title={t("profile.header.title")} icon={PageIcons.Profile} />

      <ContentWrapper>
        <ProfileEditPersonal />

        <ProfileEditCompany />

        {/* <ProfileAPIKey />

        <ProfileDeleteAccount />

        <ProfileGetSupport />
        
       <ProfileChangeTheme />
         */}
      </ContentWrapper>
    </Flex>
  );
};
